import { Component } from '@angular/core';
import { SharedModule } from '@core/modules/shared.module';
// import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-text-editor',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './text-editor.component.html',
})
export class TextEditorComponent {
  // public editorContent: string = '';
  // public editorConfig: AngularEditorConfig = {
  //   editable: true,
  //   spellcheck: true,
  //   height: 'auto',
  //   minHeight: '280px',
  //   maxHeight: 'auto',
  //   width: 'auto',
  //   minWidth: '0',
  //   translate: 'yes',
  //   enableToolbar: true,
  //   showToolbar: true,
  //   placeholder: 'Enter text here...',
  //   defaultParagraphSeparator: '',
  //   defaultFontName: 'Roboto',
  //   defaultFontSize: '13px',
  //   fonts: [
  //     { class: 'arial', name: 'Arial' },
  //     { class: 'calibri', name: 'Calibri' },
  //     { class: 'comic-sans-ms', name: 'Comic Sans MS' },
  //     { class: 'times-new-roman', name: 'Times New Roman' },
  //     { class: 'roboto', name: 'Roboto' },
  //   ],
  // };
}
